import { useGenericModal } from '..';
import {
  VoiceSelectorModal,
  VoiceSelectorModalProps,
} from './voice-selector-modal';

export const useVoiceSelectorModal = (
  props?: Partial<VoiceSelectorModalProps>
) => {
  const { modalRef, openModal, closeModal } = useGenericModal();

  const modalComponent = (
    <VoiceSelectorModal
      modalRef={modalRef}
      onClose={closeModal}
      selectedValues={
        props?.selectedValues || {
          audioModel: '',
          language: '',
          elevenlabsVoiceId: '',
        }
      }
      onVoiceSelect={props?.onVoiceSelect}
    />
  );

  return {
    modalRef,
    openModal,
    closeModal,
    voiceSelectorModal: modalComponent,
  };
};
